import { Map, List } from 'immutable';

import { TYPES } from './actions';
import { TYPES as SMS_CONVERSATIONS_TYPES } from '../smsConversations/actions';
import Logger from '../../../lib/Logger';

export default function smsMessages(
  state = Map({
    isLoading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    'debug',
    `[smsMessages.reducers] smsMessages(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.LIST_SUCCESS:
      const existingResults = state.getIn(
        [
          'pages',
          action.partnershipId,
          action.smsConversationId,
          action.order,
          action.limit,
          1,
        ],
        List()
      );

      const newResults =
        action.page === 1
          ? List(action.result)
          : existingResults.concat(List(action.result));

      return state
        .mergeDeep({
          isLoading: false,
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'pages',
            action.partnershipId,
            action.smsConversationId,
            action.order,
            action.limit,
            1,
          ],
          newResults
        );

    case TYPES.LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case SMS_CONVERSATIONS_TYPES.PATCH_SUCCESS:
      if (action.data?.clear_messages) {
        const smsConversationId = action.id;
        const partnershipId = action.partnershipId;

        return state
          .deleteIn(['pages', partnershipId, smsConversationId])
          .mergeDeep({
            total: 0,
          });
      }
      return state;

    case TYPES.CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.CREATE_SUCCESS:
      const createConversationId = action.smsConversationId;
      const createPartnershipId = action.partnershipId;
      const createMessageId = action.id;

      const createConversationPages = state.getIn([
        'pages',
        createPartnershipId,
        createConversationId,
      ]);

      let createState = state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

      if (!createConversationPages) {
        return createState;
      }

      Object.keys(createConversationPages).forEach((orderKey) => {
        const limitPages = createConversationPages[orderKey];

        if (limitPages) {
          Object.keys(limitPages).forEach((limitKey) => {
            const currentMessages = state.getIn(
              [
                'pages',
                createPartnershipId,
                createConversationId,
                orderKey,
                limitKey,
                1,
              ],
              List()
            );

            if (List.isList(currentMessages)) {
              const updatedMessages = orderKey.includes('desc')
                ? currentMessages.unshift(createMessageId)
                : currentMessages.push(createMessageId);

              createState = createState.setIn(
                [
                  'pages',
                  createPartnershipId,
                  createConversationId,
                  orderKey,
                  limitKey,
                  1,
                ],
                updatedMessages
              );
            }
          });
        }
      });

      return createState.mergeDeep({
        total: (state.get('total') || 0) + 1,
      });

    case TYPES.CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case SMS_CONVERSATIONS_TYPES.CLAIM_SUCCESS:
    case SMS_CONVERSATIONS_TYPES.RESOLVE_SUCCESS:
    case SMS_CONVERSATIONS_TYPES.ASSIGN_SUCCESS:
      const conversationId = action.id;
      const partnership = action.partnershipId;
      const newMessageId = action.data.id;

      const conversationPages = state.getIn([
        'pages',
        partnership,
        conversationId,
      ]);

      if (!conversationPages) {
        return state;
      }

      let newState = state;

      Object.keys(conversationPages).forEach((orderKey) => {
        const limitPages = conversationPages[orderKey];

        if (limitPages) {
          Object.keys(limitPages).forEach((limitKey) => {
            const currentMessages = state.getIn(
              ['pages', partnership, conversationId, orderKey, limitKey, 1],
              List()
            );

            if (List.isList(currentMessages)) {
              const updatedMessages = currentMessages.unshift(newMessageId);
              newState = newState.setIn(
                ['pages', partnership, conversationId, orderKey, limitKey, 1],
                updatedMessages
              );
            }
          });
        }
      });

      return newState.mergeDeep({
        total: (state.get('total') || 0) + 1,
      });

    case SMS_CONVERSATIONS_TYPES.REOPEN_SUCCESS:
      const reopenConversationId = action.id;
      const reopenPartnership = action.partnershipId;
      const newMessageIds = action.data.ids || [action.data.id];

      const reopenConversationPages = state.getIn([
        'pages',
        reopenPartnership,
        reopenConversationId,
      ]);

      let reopenState = state;

      if (!reopenConversationPages) {
        const defaultOrder = 'sent_at.desc';
        const defaultLimit = 20;

        const messagesList = List(newMessageIds);

        reopenState = reopenState.setIn(
          [
            'pages',
            reopenPartnership,
            reopenConversationId,
            defaultOrder,
            defaultLimit,
            1,
          ],
          messagesList
        );
      } else {
        Object.keys(reopenConversationPages).forEach((orderKey) => {
          const limitPages = reopenConversationPages[orderKey];

          if (limitPages) {
            Object.keys(limitPages).forEach((limitKey) => {
              const currentMessages = state.getIn(
                [
                  'pages',
                  reopenPartnership,
                  reopenConversationId,
                  orderKey,
                  limitKey,
                  1,
                ],
                List()
              );

              if (List.isList(currentMessages)) {
                const newMessages = List(newMessageIds);
                const updatedMessages = newMessages.concat(currentMessages);
                reopenState = reopenState.setIn(
                  [
                    'pages',
                    reopenPartnership,
                    reopenConversationId,
                    orderKey,
                    limitKey,
                    1,
                  ],
                  updatedMessages
                );
              }
            });
          }
        });
      }

      return reopenState.mergeDeep({
        total: (state.get('total') || 0) + newMessageIds.length,
      });

    case TYPES.ADD_NEW_MESSAGE:
      const addConversationId = action.smsConversationId;
      const addPartnershipId = action.partnershipId;
      const addMessageId = action.messageId;

      const addConversationPages = state.getIn([
        'pages',
        addPartnershipId,
        addConversationId,
      ]);

      if (!addConversationPages) {
        return state;
      }

      let addNewState = state;

      Object.keys(addConversationPages).forEach((orderKey) => {
        const limitPages = addConversationPages[orderKey];

        if (limitPages) {
          Object.keys(limitPages).forEach((limitKey) => {
            const allPages = limitPages[limitKey];

            if (allPages && typeof allPages === 'object') {
              Object.keys(allPages).forEach((pageKey) => {
                const pageNum = parseInt(pageKey, 10);

                const currentMessages = state.getIn(
                  [
                    'pages',
                    addPartnershipId,
                    addConversationId,
                    orderKey,
                    limitKey,
                    pageNum,
                  ],
                  List()
                );

                if (List.isList(currentMessages)) {
                  const updatedMessages = orderKey.includes('desc')
                    ? currentMessages.push(addMessageId)
                    : currentMessages.unshift(addMessageId);

                  addNewState = addNewState.setIn(
                    [
                      'pages',
                      addPartnershipId,
                      addConversationId,
                      orderKey,
                      limitKey,
                      pageNum,
                    ],
                    updatedMessages
                  );
                }
              });
            }
          });
        }
      });

      return addNewState.mergeDeep({
        total: (state.get('total') || 0) + 1,
      });

    case TYPES.CREATE_BULK_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.CREATE_BULK_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.CREATE_BULK_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `smsMessages.reducers loaded.`);
